import { BranchOfficeList } from 'hq/components/views/companies/components/company-detail/company-detail-tabs/tabs/company-branch-offices/components/branch-office-list/branch-office-list';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { LwButton } from 'redesign';
import { useNavigateWithCompanyFilter } from 'hq/components/views/companies/hooks/use-navigate-with-company-filter';
import { routes } from '../../../../../../../../../Routes';

export const CompanyBranchOffices = ({ id }: { id: string }) => {
  const generatePath = useHqRelativePath();
  const navigateWithCompanyFilter = useNavigateWithCompanyFilter();

  return (
    <>
      <LwButton
        onClick={() => {
          navigateWithCompanyFilter(generatePath(routes.BranchOfficeCreate, { companyId: id }));
        }}
        color="primary"
      >
        Vestiging aanmaken
      </LwButton>
      <BranchOfficeList companyId={id} />
    </>
  );
};
